import React from "react";
import classnames from "classnames";
import { MobileDataItem } from "ui/pages/communications/CustomEmail/components/EmailListItem/components/MobileRow/MobileDataItem";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { Tooltip } from "@my-scoot/component-library-legacy";

const MobileCard = ({
  header,
  footer,
  content = [],
  stats = [],
  statColumns = 2,
  alternate = false,
  className = "",
}) => {
  return (
    <>
      <div
        className={classnames(
          "tw-border-solid tw-border-[#E7E6E4] tw-rounded-lg",
          alternate && "tw-bg-[#FAFAFA]",
          className
        )}
      >
        {/* Header */}
        {header && (
          <>
            <div className="tw-px-3 tw-pt-4 tw-pb-1">{header}</div>
            <hr className="tw-border-none tw-h-[1px] tw-bg-[#E7E6E4] tw-mt-3 tw-mb-0" />
          </>
        )}

        {/* Content */}
        {!!content.length && (
          <div className="tw-p-3">
            {content.map((item, index) => (
              <React.Fragment key={item.title || index}>
                {item.title ? (
                  <div className="tw-flex tw-justify-between tw-gap-3 tw-text-sm">
                    <span className="tw-font-medium">{item.title}</span>

                    <div className="tw-flex tw-items-center tw-gap-1">
                      <div className="tw-text-right">{item.value}</div>

                      {item.info && (
                        <Tooltip
                          arrow
                          color="primary"
                          placement="top"
                          title={item.info}
                        >
                          <InfoOutlinedIcon
                            className="tw-text-[#8A8A8A]"
                            style={{ fontSize: 16, cursor: "pointer" }}
                          />
                        </Tooltip>
                      )}
                    </div>
                  </div>
                ) : (
                  item.value
                )}

                {index < content.length - 1 && (
                  <hr className="tw-border-none tw-h-[1px] tw-bg-[#E7E6E4] tw-my-[10px]" />
                )}
              </React.Fragment>
            ))}
          </div>
        )}

        {/* Stats */}
        {!!stats.length && (
          <>
            <hr className="tw-border-none tw-h-[1px] tw-bg-[#E7E6E4] tw-m-0" />

            <div
              className={classnames(
                "tw-grid tw-gap-2 tw-p-3",
                statColumns === 2 ? "tw-grid-cols-2" : "tw-grid-cols-3"
              )}
            >
              {stats.map((item) => (
                <MobileDataItem
                  key={item.title}
                  title={item.title}
                  data={item.data}
                  subData={item.subData}
                  icon={item.icon}
                  tooltipText={item.tooltipText}
                  color={item.color}
                  popoverText={item.popoverText}
                />
              ))}
            </div>
          </>
        )}

        {/* Footer */}
        {footer && (
          <div className="tw-border tw-border-t-0 tw-border-[#E7E6E4] tw-rounded-b-lg tw-flex tw-items-center tw-gap-2">
            {footer}
          </div>
        )}
      </div>
    </>
  );
};

export default MobileCard;
